import type { UseButtonProps } from '@pearlconvert/ui/components/button/button.types'

import { useCallback, useState } from 'react'

export const useButton = ({ onClick }: UseButtonProps) => {
  const [pressed, setPressed] = useState(false)

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      onClick?.(event)
      setPressed(!pressed)
    },
    [pressed, onClick]
  )

  return {
    pressed,
    handleClick,
  }
}
